import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const NebulaMetadata = React.lazy(() =>
    import('../NebulaMetadata')
);
const nebulaMetadataRoutesRegistry = [
    {
        path: PAGE_URL.NEBULA_METADATA_PAGE,
        element: <NebulaMetadata />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default nebulaMetadataRoutesRegistry;
